__turbopack_context__.v({
  "container": "_0FIGMa_container",
  "gridContainer": "_0FIGMa_gridContainer",
  "gridWithDrawer": "_0FIGMa_gridWithDrawer",
});
